import React from 'react';
import './OccupationalTherapy.css';

const OccupationalTherapy = () => {
  return (
    <div className="residential-treatment-container">
      <div className="main-title">Occupational Therapy at The Helping Hand Psychological Hospital</div>
      <div className="paragraph">
        At The Helping Hand Psychological Hospital, our Occupational Therapy services are dedicated to helping individuals of all ages develop, regain, and maintain the skills needed for everyday life. Our occupational therapists work closely with clients and their families to promote independence, improve participation in meaningful activities, and enhance overall quality of life through personalized, evidence-based interventions.
      </div>

      <div className="sub-title">Our Areas of Expertise</div>
      <div className="paragraph">
        Our occupational therapists provide assessment and intervention for a wide range of developmental, physical, sensory, and cognitive challenges, including:
      </div>
      <ul className="bullet-points">
        <li>Autism Spectrum Disorder (ASD)</li>
        <li>Attention-Deficit/Hyperactivity Disorder (ADHD)</li>
        <li>Sensory processing difficulties</li>
        <li>Fine and gross motor skill delays</li>
        <li>Developmental delays</li>
        <li>Learning and handwriting difficulties</li>
        <li>Activities of daily living (ADL) challenges</li>
        <li>Neurological and physical rehabilitation</li>
        <li>Cognitive and executive functioning difficulties</li>
      </ul>

      <div className="sub-title">Our Services</div>
      <div className="paragraph">
        We offer comprehensive occupational therapy services, including:
      </div>
      <ul className="bullet-points">
        <li>Occupational therapy assessments</li>
        <li>Individual therapy sessions</li>
        <li>Sensory integration therapy</li>
        <li>Fine and gross motor skill development</li>
        <li>Handwriting and school readiness programmes</li>
        <li>Activities of daily living (ADL) training</li>
        <li>Cognitive rehabilitation and executive functioning support</li>
        <li>Parent and caregiver education</li>
        <li>Home and school-based intervention programmes</li>
      </ul>

      <div className="sub-title">Our Commitment to Independence and Well-being</div>
      <div className="paragraph">
        We believe that every individual deserves the opportunity to participate confidently in daily life. Our occupational therapists are committed to providing compassionate, evidence-based care tailored to each client's unique needs. By working collaboratively with families, schools, and other healthcare professionals, we empower individuals to develop the skills, confidence, and independence needed to achieve their fullest potential.
      </div>
    </div>
  );
};

export default OccupationalTherapy;
